<script setup lang="ts">
import { Check } from 'lucide-vue-next';

import { UserInfoBlock } from '@/views/Accounts/components';

import type { UserSimplified } from '@/types/users';
import type { SelectOption } from '@/types/components';

defineProps<{
  option: SelectOption & {
    data: UserSimplified;
  };
  isSelected: (
    option: SelectOption & {
      data: UserSimplified;
    }
  ) => boolean;
}>();
</script>
<template>
  <UserInfoBlock
    class="w-[calc(100%-3rem)] hover:bg-blue-50"
    user-details-class="w-full"
    is-small
    truncate
    is-option
    :email="option.data.email"
    :full-name="option.data.fullName"
  />
  <Check
    v-if="isSelected(option)"
    data-testid="user-option-is-checked-icon"
    class="h-4 w-4 stroke-iamip-accent-blue shrink-0 ml-auto"
  />
</template>
